import { Input, Label, SelectInput } from "../../components/Form"
import KanbanPlanning from "../../components/ImpactoolsKanban/Board"
import { LoadingWithLabel } from "../../components/Loading"
import CommentsComponent from "./CommentsComponent"
import { CheckListComponent } from "./ChecklistComponent"
import { ButtonLoader } from "../../components/Button"
import { NewModalBody, NewModalHeader, NewModal } from "../../components/NewModal"
import "./styles.scss"

const PlanningScreen = ({
  data,
  loggedUser,
  foldersData,
  loadingLists,
  loadingBoards,
  loadingTask,
  loadingChecklist,
  loadingComment,
  loadingComments,
  openModalTaskDetails,
  modalOpenDetails,
  setModalOpenDetails,
  onChange,
  clickedCard,
  values,
  handleUpdateTask,
  handleCreateComment,
  openEditOptions,
  closeTextArea,
  closeTextAreaCheckList,
  showCommentAdd,
  showNewCheckListItem,
  showNewCheckListItemItem,
  openEditCheckListTitleItem,
  handleAddItemCheckList,
  handleCreateCheckListItem,
  handleCheckListItem,
  checked,
  onDragEnd,
  listOptions,
  handleSelectList,
  filteredLists
}) => {
  const statusOptionss = [
    {
      label: "Backlog",
      value: "backlog",
      color: "#87909e",
    },
    {
      label: "Em Aberto",
      value: "em aberto",
      color: "#87909e",
    },
    {
      label: "Em Andamento",
      value: "em andamento",
      color: "#1290E0",
    },
    {
      label: "Para Validação",
      value: "para validação",
      color: "#5f55ee",
    },
    {
      label: "Finalizada",
      value: "concluídas",
      color: "#008844",
    },
  ]

  const formatStatusOldProjects = (value) => {
    switch (value) {
      case "em aberto":
        return "aberto";
      case "em andamento":
        return "andamento";
      case "concluídas":
        return "complete";
      default:
        return value;
    }
  };

  const foldersOptions =
    foldersData && foldersData?.length > 0
      ? foldersData?.map(({ id, name }) => ({ value: id, label: name }))
      : []

  return (
    <>
      {loadingBoards ? (
        <div className="kanban-content-loading">
          <LoadingWithLabel
            labelLoading="Buscando quadros, aguarde..."
            sizeSpinner="large"
            colorSpinner="primary"
          />
        </div>
      ) : (
        !loadingBoards &&
        foldersData?.length > 0 && (
          <>
            <div className="select-boards">
              <div className="select-board">
                <Label label="Quadro" />
                <SelectInput
                  defaultValue={foldersOptions[0] || ""}
                  onChange={(value) => onChange("foldersData", value)}
                  options={foldersOptions}
                  whiteVariation={true}
                />
              </div>
              <div className="select-board">
                <Label label="Projetos" />
                <SelectInput
                  defaultValue={filteredLists || []}
                  onChange={(value) => handleSelectList(value)}
                  placeholder="Agrupar por projeto(s)"
                  options={listOptions}
                  whiteVariation
                  isMulti
                />
              </div>
            </div>
            
            <KanbanPlanning
              onDragEnd={onDragEnd}
              isInitialLoading={loadingLists}
              data={data}
              openModalTaskDetails={openModalTaskDetails}
            />
            {modalOpenDetails && (
              <NewModal
                width={700}
                modalIsOpen={modalOpenDetails}
                shouldCloseOnOverlayClick={true}>
                <NewModalHeader
                  buttonCloseDisabled={loadingTask || loadingLists}
                  closeModal={() => setModalOpenDetails(false)}
                  line={false}>
                  <div className="details-planning-section__title">
                    <h2>{clickedCard?.title}</h2>
                    <span>
                      {clickedCard?.folder?.name} / {clickedCard?.list?.name}
                    </span>
                  </div>
                  <div className="button-update-task">
                    <ButtonLoader
                      loading={loadingTask || loadingLists}
                      color="primary"
                      messageProcess="Salvando"
                      label="Salvar"
                      handleClick={handleUpdateTask}
                    />
                  </div>
                </NewModalHeader>
                <NewModalBody>
                  {clickedCard && Object.keys(clickedCard).length > 0 && (
                    <div className="details-planning">
                      <div className="details-planning-section">
                        <div className="details-planning-section__body">
                          <div className="details-planning-section__body-info">
                            <div className="details-planning-section__body-info__status">
                              <Label label="Status" />
                              <SelectInput
                                defaultValue={statusOptionss.filter(
                                  (item) => formatStatusOldProjects(item?.value) === clickedCard?.status?.status,
                                )}
                                onChange={(value) => onChange("status", value)}
                                options={statusOptionss}
                                isOverModal={true}
                                menuShouldBlockScroll={true}
                              />
                            </div>

                            <div className="details-planning-section__body-info__date">
                              <div className="date">
                                <Label label="Início" />
                                <Input
                                  type="date"
                                  value={values?.startDate}
                                  onChange={(e) => onChange("startDate", e?.target?.value)}
                                />
                              </div>
                              <div className="date">
                                <Label label="Vencimento" />
                                <Input
                                  type="date"
                                  value={values?.dueDate || ""}
                                  onChange={(e) => onChange("dueDate", e?.target?.value)}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="details-planning-section__description last-description">
                            <Label label="Descrição" />
                            <div className="description-creator">
                              <div className="text-box">
                                <div className="text-box-only-visible">
                                  <span>{clickedCard?.description}</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          {clickedCard?.checklists?.length > 0 && (
                            <CheckListComponent
                              {...{
                                loadingChecklist,
                                clickedCard,
                                onChange,
                                showNewCheckListItem,
                                showNewCheckListItemItem,
                                openEditCheckListTitleItem,
                                handleAddItemCheckList,
                                closeTextAreaCheckList,
                                handleCreateCheckListItem,
                                values,
                                handleCheckListItem,
                                checked,
                              }}
                            />
                          )}

                          <CommentsComponent
                            {...{
                              loggedUser,
                              clickedCard,
                              onChange,
                              values,
                              handleCreateComment,
                              openEditOptions,
                              closeTextArea,
                              showCommentAdd,
                              loadingComment,
                              loadingComments
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </NewModalBody>
              </NewModal>
            )}
          </>
        )
      )}
    </>
  )
}

export default PlanningScreen
